var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),(_vm.chartLoading)?_c('v-progress-circular',{staticClass:"loading-circle",attrs:{"size":70,"rotate":30,"width":5,"indeterminate":""}}):_c('apex-chart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }